import { useTranslation } from 'react-i18next';
import EmptyState from '../../../../EmptyState';

export interface Props {
  clearSearch: () => void;
}

export function GallectionsEmptyState({ clearSearch }: Props) {
  const { t } = useTranslation();
  return (
    <EmptyState
      title={t('pages.gallections.search.emptyState.title')}
      subtitle={t('pages.gallections.search.emptyState.subtitle')}
      withButton
      buttonLabel={t('pages.gallections.search.emptyState.buttonCTA')}
      onButtonClick={clearSearch}
    />
  );
}

export default GallectionsEmptyState;
